<template>
  <div v-if="collapsed" class="history-item-condensed">
    <div style="display: flex; justify-content: space-between; align-items: center">
      <div>
        <vs-text type="caption" bold
          >{{ formatDateTimeWithYear(item.startedAt)
          }}<span :style="`padding-left: 8px; font-weight:bold; color: ${statusColor}`">{{
            statusText
          }}</span></vs-text
        >
        <vs-text type="caption">Requested By: {{ item.requestedBy || 'Admin' }}</vs-text>
      </div>
      <div>
        <vs-text v-if="item.externalInvoice" type="caption"
          ><a :href="item.externalInvoice.link" target="_blank"
            >#{{ item.externalInvoice?.displayName }}
            <v-icon x-small color="#065fd4">mdi-open-in-new</v-icon></a
          ></vs-text
        >
      </div>
    </div>
  </div>
  <div v-else class="history-item">
    <vs-text
      >Status:
      <span :style="`font-weight:bold; color: ${statusColor}`">{{ statusText }}</span></vs-text
    >
    <vs-text>Ran: {{ formatDateTimeWithYear(item.startedAt) }}</vs-text>
    <vs-text>Requested By: {{ item.requestedBy || 'Admin' }}</vs-text>
    <vs-text v-if="item.externalInvoice"
      >Invoice Link:
      <a :href="item.externalInvoice.link" target="_blank"
        >#{{ item.externalInvoice?.displayName }}
        <v-icon x-small color="#065fd4">mdi-open-in-new</v-icon></a
      ></vs-text
    >
    <div class="errors-section" v-if="item.errors">
      <vs-text type="intro" bold style="margin: var(--space-base) 0">Errors</vs-text>
      <batch-sync-history-error-item v-for="error in item.errors" :error="error" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, toRef } from 'vue'
import FormLayout from '@/components/common/FormLayout.vue'
import VsForm from '@/components/vision/VsForm.vue'
import VsText from '@/components/vision/VsText.vue'
import { useInvoiceSyncTargetHistoryQuery, useInvoiceSyncTargetsQuery } from '@/api/invoice'
import { SyncTargetHistory } from '@/models/batch'
import { formatDateTime, formatDateTimeWithYear } from '@/utils/date-formatting'
import BatchSyncHistoryErrorItem from '@/components/batches/BatchSyncHistoryErrorItem.vue'

const props = defineProps<{
  collapsed?: boolean
  item: SyncTargetHistory
}>()

const collapsedRef = ref<boolean>(props.collapsed || false)
const itemRef = toRef(props, 'item')

const statusText = computed(() => {
  if (itemRef.value.status === 'Success') {
    return itemRef.value.errors.length === 0 ? `Success` : `Succeeded with warnings`
  }
  return itemRef.value.status
})

const statusColor = computed(() => {
  if (itemRef.value.status === 'Success') {
    return itemRef.value.errors.length === 0 ? `#21612e` : `#c9741b`
  }
  if (itemRef.value.status === 'Failed') {
    return '#a00d0d'
  }
  return '#333'
})
</script>

<style scoped>
.history-item {
  margin-bottom: var(--space-larger);
}

.history-item-condensed {
  margin: var(--space-small) 0;
}

.error-card {
  margin: 16px 0px;
  border-left: solid 4px darkred;
  padding: 0px 16px;
  border-radius: var(--space-smaller);
}

.errors-section {
  margin-bottom: var(--space-larger);
}
</style>
